var  $body, $modal, $secondaryModal, $window,sidebar_pos, sidebar_width,ajax_contents,scroll_from_top,menu_scroll;
var timeout = false;
var rtime;
var delta = 500;
var waypoints;
var animations = {};

$(window).resize(function() {
  equalizeHeight('.livesafe-title');
  rtime = new Date();
  if (timeout === false) {
    timeout = true;
    setTimeout(resizeend, delta);
  }
});
function resizeend() {
  if (new Date() - rtime < delta) {
    setTimeout(resizeend, delta);
  } else {
    timeout = false;
    resizeHandler();
  }
}
function autosize(){
  var el = this;
  setTimeout(function(){
    el.style.cssText = 'height:auto; padding:0';
	 var txt_height = el.scrollHeight + 30;
    el.style.cssText = 'min-height:' + el.scrollHeight + 'px';
	 
  },0);
}
	


$(window).load(function () {
	"use strict";
	
	$body = $('body');
	$window = $(window);
	
	setTimeout(function () {
		$('#content_wrapper').removeClass("loading");
		$('#content_wrapper').addClass('loaded');
		
		
		equalizeHeight('.livesafe-title');
	
		
		waypoints = $('.way-point-animate').waypoint(function(direction) {
			$(this.element).addClass('shown');
		}, {
			offset: '90%'
		});
		waypoints = $('.way-point-animate-left').waypoint(function(direction) {
			$(this.element).addClass('shown');
		}, {
			offset: '90%'
		});
		waypoints = $('.way-point-animate-right').waypoint(function(direction) {
			$(this.element).addClass('shown');
		}, {
			offset: '90%'
		});
		
		$('#content_wrapper #main_wrapper').animate({
			opacity: 1
		}, 300);
		
		$.cookieBar({
			element: 'body',
			zindex: '999999',
			message: PRIVACY,
			acceptText: '',
			//policyText: 'MORE',
			//policyURL: '#,
			domain: 'www.livesafe.gr',
			referrer: 'www.livesafe.gr'
		});
		
		setTimeout(function() {
			$(".subtitle h2").addClass('visible');
			setTimeout(function() {
				$(".hero-container .description").addClass('visible');
			}, 500);
		}, 500);
		
	}, 200);	
	
	
	
});


$(function(){
	"use strict";
	
    $(document).on("click", ".load-more", function () {
		var target = $(this).data('target');
		more(target);
		return false;
	});
	
	
	$('select').select2({
		  minimumResultsForSearch: Infinity
	});
	
	$(document).on('click', ".modal-btn", function (e) {
		try{
			e.preventDefault();			
		   if($(this).attr("href")){
				openAjaxModal($(this).attr('href'), $('#'+ $(this).data('modal')));				
			}else{
				openAjaxModal($(this).data('href'), $('#'+ $(this).data('modal')));				
			}	
		}catch(Error){
			console.log(Error);
		}
		return false;
	});
	
	callbacks();
});


function equalizeHeight(target){
	 setTimeout(function(){
        var min_height = 0;
        var tt = $(target);
        tt.css('min-height',0);
        tt.each(function(){
            var t = $(this);
            var adjusted_height = Math.ceil(t.outerHeight() + 5)
            if(adjusted_height > min_height){
                min_height = adjusted_height;
            }
        });

        if(min_height>0){
            tt.css('min-height',min_height);
            tt.css('height','100%');
        }

    },300);
}

function initShares(){
	"use strict";
	$('.close-share-this').click(function(){
		$('.modal.in').modal('hide');
		return false;
	});
	
	var clipboard = new Clipboard('.clipboardButton');
	clipboard.on('success', function(e) {
		console.info('Action:', e.action);
		console.info('Text:', e.text);
		console.info('Trigger:', e.trigger);
		
		$('.clipboardButton .copy-label').text(' copied!');
		
		e.clearSelection();
	});
	clipboard.on('error', function(e) {
		console.error('Action:', e.action);
		console.error('Trigger:', e.trigger);
		
	});		
}

function openAjaxModal(href,$mm){
	
    $m = $mm || $modal;

    $m.removeData('bs.modal');
    $m.empty();
    $m.load(href,function(){
        $m.modal('show');
        //skinFormElements('#'+$m.attr('id'));
        callbacks('#'+$m.attr('id'));
    });
}

var filterXHRPull = {};

function filter(target) {
    var after = arguments[1];
    $('form[name="' + target + '-nav"] input[name="page"]').val(0);
    var request_data = $('form[name="' + target + '-nav"]').serializeArray(),
        excludes = ['module', 'action', 'active_for', 'language_id', 'data_type', 'country_code'],
        includes = ['sort_term','sort_way'],
        elements = {};
    var initialHeight = $('.' + target + '-list').innerHeight();
    $('.' + target + '-list').height(initialHeight).css({'min-height':100,'overflow':'hidden'}).html('<div class="loading la-animate"></div>');
    if(typeof(filterXHRPull[target]) !== 'undefined' && filterXHRPull[target]!==null){
        filterXHRPull[target].abort();
    }
    filterXHRPull[target] = $.ajax({data: request_data, dataType: 'html',
        success: function (data) {
            $('.' + target + '-list').css({'overflow':'visible'});
            $('.' + target + '-list').html(data).height('auto');
            var num_items = $('.' + target + '-list .item').length;
            var offset = Number($('form[name="' + target + '-nav"] input[name="offset"]').val());
			$('form[name="' + target + '-nav"] input[name="page"]').val(0);
            callbacks('.' + target + '-list');
            if (after) {
                after.call();
            }else if($('.' + target + '-list').data('afterFilter')){
                window[$('.' + target + '-list').data('afterFilter')]( $('.' + target + '-list').data('afterFilterParams') );
            }
            if(num_items === offset){
                $('.load-more[data-target="'+target+'"]').show();
                if($('.' + target + '-list').height() < $(window).height() - $('header').height()){
                    more(target);
                }
            }else{
                $('.load-more[data-target="'+target+'"]').hide();
            }
            delete filterXHRPull[target];
        },
        complete: function(data){
			setEqualHeights('.press-releases .item .caption');
		}
    });
}

function more(target) {
	"use strict";
    if ($('form[name="' + target + '-nav"] ').hasClass('busy')) {
        return false;
    }

    var c = $('form[name="' + target + '-nav"] input[name="page"]').val();
    var offset = $('form[name="' + target + '-nav"] input[name="offset"]').val();
    $('form[name="' + target + '-nav"] input[name="page"]').val(Number(c) + 1);
    $('form[name="' + target + '-nav"]').addClass('busy');
    $('.load-more[data-target="'+target+'"]').hide();
    $.ajax({data: $('form[name="' + target + '-nav"]').serialize(), dataType: 'html', success: function (result) {
        $('form[name="' + target + '-nav"]').removeClass('busy');

        var $result = $('<div>' + result + '</div>');

        var num_items = $result.find('.item').length;
        if ( num_items > 0) {
            $result.find('.item').hide();
            $('.' + target + '-list').append($result.html());
            $('.' + target + '-list .item').fadeIn('fast');

            callbacks('.' + target + '-list');
            $('.load-more[data-target="'+target+'"]').show();
        } else {
            $('.load-more[data-target="'+target+'"]').hide();
        }

        if($('.' + target + '-list').data('afterFilter')){
            window[$('.' + target + '-list').data('afterFilter')]($('.' + target + '-list').data('afterFilterParams'));
        }
    },
    complete: function(data){
			setEqualHeights('.press-releases .item .caption');
        }
    });
}

/*function more(target){
	var next_page = Number($('form[name="'+target+'-nav"] input[name="page"]').val()) + 1;
	var all_pages = Number($('form[name="'+target+'-nav"] input[name="num_pages"]').val());
	
	$('form[name="'+target+'-nav"] input[name="page"]').val(next_page);
	
	$('.more-results[rel="'+target+'"]').addClass('loading');
	$.ajax({
		data:$('form[name="'+target+'-nav"]').serialize(),
		dataType:'html',
		success:function(data){
			$newItems = $.parseHTML( data );
			$.each( $newItems, function( i, el ) {
				$(el).data('duration', i ).appendTo('#'+target+'-list');			
			});			
			if(next_page===all_pages-1){
				$('.more-results[rel="'+target+'"]').hide();
			}else{
				$('.more-results[rel="'+target+'"]').removeClass('loading');		
			}
			clickEvents();
		}
	});
}*/


function deepLinking(target){
    var request_data = $('form[name="' + target + '-nav"]').serializeArray(),
        excludes = ['module', 'action', 'active_for', 'language_id', 'data_type', 'country_code'],
        includes = [
            'group',
            'sort_term',
            'sort_way'
		],
        elements = {};

        for (var i in request_data) {
            if (typeof(request_data[i]['value']) === 'string' && ( in_array(request_data[i]['name'], includes) || request_data[i]['name'].indexOf('attributes[') === 0) ) {
                var key_name = (request_data[i]['name'] == 'search_param')?'q':request_data[i]['name'];

                if(typeof(elements[key_name]) === 'undefined'){
                    elements[key_name] = [];
                }
                elements[key_name].push(request_data[i]['value']);
			}
		}

    if(!$.isEmptyObject(elements)){
        var h = '?';
        var del = '';
        for(var i in elements){
            h += del + i.replace('[]','') + '='+elements[i].join(',');
            del = '&';
        }

        if(h!=getQueryString()){
            history.pushState({title:h}, '' , h);

            try{

                _paq.push(['setCustomUrl', h]);
                _paq.push(['setDocumentTitle', document.title]);
                _paq.push(['trackPageView']);
                ga('send', 'pageview', h);


            }catch(Error){}
        }

    }
}

function callbacks(c) {
	"use strict";
    var container = c || '';
    //ajaxContent(container + ' .ajax-content');

    $(container + ' .callbacks').each(function () {
        if(!$(this).hasClass('callbacks-executed')){
            if(container !=='' || !$(this).hasClass('callbacks-executed')){
                var c = $(this).data();
                for (var i in c) {
                    if (i.indexOf('fn') === 0 && c[i] !== '') {
                        var fn = c[i];
                        var params = c[ 'params' + i ] || null;

                        try {
                            if (c[ 'after' + i ] && typeof(window[c[ 'after' + i ]]) === 'function') {

                                var callbackAfter = c[ 'after' + i ];
                                var callbackAfterParams = c[ 'after' + i + 'Params' ] || null;

                                window[ fn ](params, function(){
                                    window[callbackAfter](callbackAfterParams);
                                });
                            } else {
                                window[ fn ](params);
                            }
							$(this).addClass('callbacks-executed');
                        } catch (Error) {
                            console.log(Error + ' '+fn);
                        }
                    }
                }
            }
        }
    });
}

function ajaxContent(c){
	"use strict";	
    $modal = $('#modal');
    var contents = c || '.ajax-content';
    $(contents).each(function () {
        ajax_contents.push(
            {
                'content':$(this).data('ajaxContent'),
                'target': $(this)
            }
        );
    });
    loadAjaxContent();
}

function loadAjaxContent(){
	"use strict";
    if(ajax_contents.length > 0){
        var target = ajax_contents[0]['target'],content =  ajax_contents[0]['content'];
        if(target.hasClass('ajax-load-initiated')) {
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
            return false;
        }

        target.addClass('ajax-load-initiated');

        target.load(content,function(){
            var uniq = (Math.random() + '').replace('0.', '');

            target.addClass('ajax-loaded-'+uniq);
            callbacks('.ajax-loaded-'+uniq);
            ajax_contents.splice(0, 1);
            if(ajax_contents.length > 0){
                loadAjaxContent();
            }
        });
    }else{
        $('.ajax-load-initiated').removeClass('ajax-load-initiated');
    }
}